var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"color":"primary","indeterminate":"","height":"6"}})
}
var staticRenderFns = []

export { render, staticRenderFns }